import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  AbstractControl,
} from "@angular/forms";
import {
  NavController,
  NavParams,
  ToastController,
  LoadingController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AcompanhamentoAddPartPage } from "../acompanhamento-add-part/acompanhamento-add-part.page";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";
import { ConfigProvider } from "src/app/services/config/config";
import { format, parseISO } from "date-fns";
import { CommonModule } from "@angular/common";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { UserProvider } from "src/app/services/user/user";
import { ProverHorasComponent } from "src/app/components/prover-horas/prover-horas.component";
import { noWhitespaceValidator } from "src/app/pipes/no-white-space-validator/no-white-space-validator";

@Component({
  selector: "app-acompanhamento-add",
  templateUrl: "./acompanhamento-add.page.html",
  styleUrls: ["./acompanhamento-add.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DateFormatPipe,
    TranslateModule,
    ProverDatepickerComponent,
    ProverHorasComponent,
  ],
})
export class AcompanhamentoAddPage implements OnInit {
  categoriaList: any = [];
  acaoList: any = [];
  statusList: any = [];
  validations_form: FormGroup;
  acompanhamento: any = {};
  horaFim = format(new Date(), "HH:mm");
  horaIni = format(new Date(), "HH:mm");
  disabled = false;
  submitted = false;
  disabledCompromisso: boolean = false;
  isAcompanhamento: boolean = false;

  simNaoList: any = [
    { id: "0", nome: this.translate.instant("SIM") },
    { id: "1", nome: this.translate.instant("NÃO") },
  ];
  tipoList: any = [
    { id: "0", nome: this.translate.instant("Acompanhamento") },
    { id: "1", nome: this.translate.instant("Compromisso") },
  ];
  validation_messages = {
    tipo: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    idCategoria: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    idAcompanhamentoOperacao: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    idAcompanhamentoStatus: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    restrito: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    dataHora_data: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    anotacao: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    dataHora_hora: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    dataHoraFim_data: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    dataHoraFim_hora: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    descricao: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
    titulo: [{ type: "required", message: this.translate.instant("Campo Obrigatório") }],
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public configProvider: ConfigProvider,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    private translate: TranslateService,
    public formBuilder: FormBuilder,
    public userProvider: UserProvider
  ) {
    this.acompanhamento = this.navParams.get("acompanhamento");
    this.isAcompanhamento = this.navParams.get("isAcompanhamento");

    this.disabled = this.acompanhamento && !this.userProvider.hasConfig(214) && !this.isAcompanhamento;
    this.disabledCompromisso = this.acompanhamento && !this.userProvider.hasConfig(213) && !this.isAcompanhamento;

    this.validations_form = this.formBuilder.group({
      tipo: new FormControl(
        "0",
        this.acompanhamento && this.acompanhamento.id ? Validators.nullValidator : Validators.required
      ),
      idCategoria: new FormControl(
        { value: "", disabled: this.disabled },
        this.acompanhamento && this.acompanhamento.isCompromisso == "1" ? Validators.nullValidator : Validators.required
      ),
      idAcompanhamentoOperacao: new FormControl(
        { value: "", disabled: this.disabled },
        this.acompanhamento && this.acompanhamento.isCompromisso == "1" ? Validators.nullValidator : Validators.required
      ),
      idAcompanhamentoStatus: new FormControl(
        { value: "", disabled: this.disabledCompromisso },
        this.acompanhamento && this.acompanhamento.isCompromisso == "1" ? Validators.nullValidator : Validators.required
      ),
      restrito: new FormControl(
        { value: "", disabled: this.disabledCompromisso },
        this.acompanhamento && this.acompanhamento.isCompromisso == "1" ? Validators.nullValidator : Validators.required
      ),
      descricao: new FormControl({ value: "", disabled: this.disabledCompromisso }, [
        (control: AbstractControl) => {
          const value = control.value;
          return !value || value.trim().length === 0 ? { required: true } : null;
        },
      ]),

      dataHora_data: new FormControl(
        { value: format(new Date(), "yyyy-MM-dd"), disabled: this.disabledCompromisso },
        Validators.required
      ),
      dataHora_hora: new FormControl({ value: "", disabled: this.disabledCompromisso }, Validators.required),
      dataHoraFim_data: new FormControl(
        { value: format(new Date(), "yyyy-MM-dd"), disabled: this.disabledCompromisso },
        Validators.required
      ),
      dataHoraFim_hora: new FormControl({ value: "", disabled: this.disabledCompromisso }, Validators.required),
      titulo: new FormControl({ value: "", disabled: this.disabledCompromisso }, [
        Validators.nullValidator,
        noWhitespaceValidator,
      ]),
    });

    this.acompanhamentoProvider.getDadosBasicos().subscribe((data) => {
      this.categoriaList = data.categorias;
      this.statusList = data.status;

      if (this.acompanhamento && this.acompanhamento.id) {
        this.carregarForm();
      }
    });

    const tipo = this.navParams.get("tipo") == "acompanhamento" ? "0" : "1";
    this.validations_form.get("tipo")?.setValue(tipo);
    this.tipoChange({ detail: { value: tipo } });
  }

  ngOnInit() {}

  carregarForm() {
    this.horaFim = format(parseISO(this.acompanhamento.dataHoraFim), "HH:mm");
    this.horaIni = format(parseISO(this.acompanhamento.datahora), "HH:mm");

    if (this.acompanhamento.idCategoria) {
      this.validations_form.controls["tipo"].setValue("0");
      this.validations_form.controls["idCategoria"].setValue(this.acompanhamento.idCategoria);
      this.validations_form.controls["restrito"].setValue(this.acompanhamento.restrito);
      this.validations_form.controls["idAcompanhamentoOperacao"].setValue(this.acompanhamento.idAcompanhamentoOperacao);
      this.validations_form.controls["idAcompanhamentoStatus"].setValue(this.acompanhamento.idAcompanhamentoStatus);
    } else {
      this.validations_form.controls["tipo"].setValue("1");
    }

    if (!this.isAcompanhamento) {
      this.validations_form.controls["dataHora_data"].setValue(
        format(parseISO(this.acompanhamento.datahora), "yyyy-MM-dd")
      );
      this.validations_form.controls["dataHora_hora"].setValue(this.horaIni);
      this.validations_form.controls["dataHoraFim_data"].setValue(
        format(parseISO(this.acompanhamento.dataHoraFim), "yyyy-MM-dd")
      );
      this.validations_form.controls["dataHoraFim_hora"].setValue(this.horaFim);
    }

    this.validations_form.controls["descricao"].setValue(this.acompanhamento.descricao);
    this.validations_form.controls["titulo"].setValue(this.acompanhamento.titulo);
    this.changeAcao(this.acompanhamento.idCategoria);
  }

  changeAcao(categoria: any) {
    const idCategoria = categoria.detail ? categoria.detail.value : categoria;
    const acao = this.categoriaList.find((categoria: { id: string }) => categoria.id == idCategoria);
    this.acaoList = acao ? acao.acoes : [];
  }

  async validarDataHora(): Promise<boolean> {
    const inicioData = this.validations_form.get("dataHora_data")?.value;
    const inicioHora = this.validations_form.get("dataHora_hora")?.value;
    const fimData = this.validations_form.get("dataHoraFim_data")?.value;
    const fimHora = this.validations_form.get("dataHoraFim_hora")?.value;

    const inicio = new Date(`${inicioData}T${inicioHora}`);
    const fim = new Date(`${fimData}T${fimHora}`);

    if (fim < inicio) {
      const toast = await this.toastCtrl.create({
        message: "A data/hora final não pode ser menor que a inicial",
        duration: 3000,
      });
      await toast.present();
      return false;
    }

    return true;
  }

  async proximo() {
    this.submitted = true;

    this.validateAllFormFields(this.validations_form);
    const valido = await this.validarDataHora();
    if (!valido) return;

    if (this.validations_form.valid) {
      const modalPage = await this.modalCtrl.create({
        component: AcompanhamentoAddPartPage,
        componentProps: { acompanhamento: this.validations_form.value },
        animated: false,
      });
      modalPage.present();
      const data = await modalPage.onWillDismiss();
      if (data && data.data) {
        setTimeout(() => {
          this.modalCtrl.dismiss(data.data);
        }, 10);
      }
    }
  }

  tipoChange(event: { detail: { value: string } }) {
    const idAcompanhamentoOperacao = this.validations_form.get("idAcompanhamentoOperacao");
    const idCategoria = this.validations_form.get("idCategoria");
    const idAcompanhamentoStatus = this.validations_form.get("idAcompanhamentoStatus");
    const restrito = this.validations_form.get("restrito");
    const titulo = this.validations_form.get("titulo");

    if (event.detail.value === "0") {
      idAcompanhamentoOperacao?.setValidators(Validators.required);
      idCategoria?.setValidators(Validators.required);
      idAcompanhamentoStatus?.setValidators(Validators.required);
      restrito?.setValidators(Validators.required);
      titulo?.setValidators([Validators.nullValidator]);
    } else {
      idAcompanhamentoOperacao?.clearValidators();
      idCategoria?.clearValidators();
      idAcompanhamentoStatus?.clearValidators();
      restrito?.setValidators([Validators.nullValidator]);
      titulo?.setValidators([Validators.required, noWhitespaceValidator]);
    }

    idAcompanhamentoOperacao?.updateValueAndValidity();
    idCategoria?.updateValueAndValidity();
    idAcompanhamentoStatus?.updateValueAndValidity();
    restrito?.updateValueAndValidity();
    titulo?.updateValueAndValidity();
  }

  async salvar() {
    this.submitted = true;
    this.validateAllFormFields(this.validations_form);
    const valido = await this.validarDataHora();
    if (!valido) return;
    if (this.validations_form.valid) {
      var dados: any = this.acompanhamentoProvider.tratarConteudo(this.validations_form.value, [], []);
      dados.acompanhamento.id = this.acompanhamento.id;

      this.acompanhamentoProvider.salvarAcompanhamentoDetalhes(dados.acompanhamento).subscribe(async (data) => {
        this.modalCtrl.dismiss(data.acompanhamento);

        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Acompanhamento salvo com sucesso"),
          duration: 3000,
        });

        toast.present();
      });
    }
  }

  async salvarCompromisso() {
    this.submitted = true;
    this.validateAllFormFields(this.validations_form);
    const valido = await this.validarDataHora();
    if (!valido) return;

    if (this.validations_form.valid) {
      var dados: any = this.acompanhamentoProvider.tratarConteudo(this.validations_form.value, [], []);
      dados.acompanhamento.id = this.acompanhamento && this.acompanhamento.id ? this.acompanhamento.id : "";
      this.acompanhamentoProvider.salvarCompromissoDetalhes(dados.acompanhamento).subscribe(async (data) => {
        this.modalCtrl.dismiss(data.acompanhamento);
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Compromisso salvo com sucesso"),
          duration: 3000,
        });
        toast.present();
      });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async salvarSubsequente() {
    this.validateAllFormFields(this.validations_form);

    if (!this.validations_form.valid) {
      return;
    }

    const idAcompanhamentoPai = this.acompanhamento.idAcompanhamentoPai || this.acompanhamento.id;
    this.validations_form.value.idAcompanhamentoPai = idAcompanhamentoPai;

    const data = {
      acompanhamento: this.validations_form.value,
      participantes: this.acompanhamento.participantes,
      isAcompanhamento: this.isAcompanhamento,
    };
    if (this.validations_form.valid) {
      const modalPage = await this.modalCtrl.create({
        component: AcompanhamentoAddPartPage,
        componentProps: data,
        animated: false,
      });
      modalPage.present();

      const result = await modalPage.onWillDismiss();
      if (result) {
        await modalPage.dismiss();
        await this.modalCtrl.dismiss();
      }
    }
  }
}
